/* eslint-disable react/require-default-props */
import * as React from "react";
import { keyframes } from "@emotion/core";
import { cx, css } from "@emotion/css";

interface SubmitButtonProps {
  isSubmitting?: boolean;
  disabled?: boolean;
  text?: string;
  onClick?: (e: React.SyntheticEvent) => void;
}

const btnClass = css`
  border: 0;
  padding: 12px;
  text-shadow: none;
  font-size: 1em;
  line-height: 1em;
  border-radius: 3px;
  font-size: 0.85em;
  text-transform: uppercase;

  :active {
    box-shadow: none;
  }
`;

const primaryBtnClass = css`
  background: #007eb7;
  color: #fff;
  font-size: 15px;
  text-transform: uppercase;

  :hover {
    background: #0098d0;
    text-shadow: none;
    color: #fff;
  }
`;

const btnOutlineClass = css`
  border: 1px solid #007eb7;
  border-radius: 3px;
  color: #007eb7;
`;

const primaryDisabledClass = css`
  background: #dfd9d9;
  color: #8a9191;
`;

const spinnerKeyFrames = keyframes`
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
  }
`;

const spinnerClass = css`
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: white;
  border-radius: 50%;
  opacity: 0;
  animation: ${spinnerKeyFrames} 0.75s linear infinite;
`;

export const SubmitButton = ({
  isSubmitting = true,
  disabled = false,
  text = "Submit Application",
  onClick,
  ...rest
}: SubmitButtonProps) => {
  return (
    <button
      id="submit"
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cx(
        btnClass,
        {
          [btnOutlineClass]: !disabled
        },
        primaryBtnClass,
        {
          [primaryDisabledClass]: disabled
        }
      )}
      {...rest}
    >
      {isSubmitting ? (
        <div>
          <span className={spinnerClass} role="status" aria-hidden="true" />
          <span>Submitting...</span>
        </div>
      ) : (
        <span> {text}</span>
      )}
    </button>
  );
};
